module.exports = __webpack_public_path__ + "static/media/gail58.5f47927d.png";